import * as api from "../api/index";
import {
  ADD_NEW,
  UPDATE,
  DELETE,
  GET_INVOICE,
  FETCH_INVOICE_BY_USER,
  FETCH_INVOICE_BY_CLIENT,
  FETCH_ALL,
  START_LOADING,
  END_LOADING,
  FETCH_DELETED_INVOICES,
  FETCH_CANCELED_INVOICES,
  FETCH_COMPLIMENTARY_INVOICES,
  CANCEL_INVOICE,
  SOFTDELETE,
} from "./constants";

// Fetch all invoices
export const getInvoices = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchInvoices();
    dispatch({ type: FETCH_ALL, payload: data });
    console.log("Fetched invoices:", data);
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

// Fetch minimal invoices with pagination (only specific fields for Invoices.js component)
export const getMinimalInvoices = (page = 1, limit = 25, startDate = null, endDate = null) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchMinimalInvoices(page, limit, startDate, endDate);
    dispatch({ type: FETCH_ALL, payload: data });
    console.log("Fetched minimal invoices:", data);
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

// Fetch invoices by user
export const getInvoicesByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const {
      data: { data },
    } = await api.fetchInvoicesByUser(searchQuery);
    dispatch({ type: FETCH_INVOICE_BY_USER, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};

// Fetch single invoice
export const getInvoice = (id) => async (dispatch) => {
  const user = JSON.parse(localStorage.getItem("profile"));

  try {
    const { data } = await api.fetchInvoice(id);
    const businessDetails = await api.fetchProfilesByUser(user.result._id);
    const invoiceData = { ...data, businessDetails };
    console.log("Fetched invoice data:", invoiceData);
    dispatch({ type: GET_INVOICE, payload: invoiceData });
  } catch (error) {
    console.log(error.response);
  }
};

// Fetch invoices by client
export const getInvoicesByClient = (clientId, page = 0, rowsPerPage = 25, startDate = "", endDate = "") =>
  async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.fetchInvoicesByClient({
        page,
        rowsPerPage,
        id: clientId,
        startDate,
        endDate,
      });
      dispatch({ type: FETCH_INVOICE_BY_CLIENT, payload: data });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.log(error.response);
    }
  };

// Create invoice (QR logic handled on backend)
// export const createInvoice = (invoice, staffCommissionDetailsArray, history, options = {}) => async (dispatch) => {
//   try {
//     dispatch({ type: START_LOADING });
//     const { data } = await api.addInvoice(invoice);
//     dispatch({ type: ADD_NEW, payload: data });
//     if (!options?.suppressRedirect && history && typeof history.push === 'function') {
//       history.push(`/invoice/${data._id}`);
//     }
//     dispatch({ type: END_LOADING });
//     return data;
//   } catch (error) {
//     // Handle double-booked seat error
//     if (error.response && error.response.status === 400 && error.response.data.message) {
//       alert(error.response.data.message);
//     } else {
//       console.log(error);
//     }
//     dispatch({ type: END_LOADING });
//   }
// };



// Create invoice (QR logic handled on backend)
export const createInvoice =
  (invoice, staffCommissionDetailsArray, history, options = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });

      // Call backend
      const { data } = await api.addInvoice(invoice);

      // Save invoice in Redux
      dispatch({ type: ADD_NEW, payload: data });

      // Redirect
      if (!options?.suppressRedirect && history && typeof history.push === "function") {
        history.push(`/invoice/${data._id}`);
      }

      // Optional: Debug / print QR codes
      if (data.qrTokens?.length) {
        console.log("QR Codes for stations:");
        data.qrTokens.forEach((qr) => {
          console.log(
            `${qr.station}: ${qr.qrUrl} (Scanned: ${qr.scanned})`
          );
        });
      }

      dispatch({ type: END_LOADING });
      return data;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 400 &&
        error.response.data.message
      ) {
        alert(error.response.data.message);
      } else {
        console.error(error);
      }
      dispatch({ type: END_LOADING });
    }
  };



// Update invoice
export const updateInvoice = (id, invoice) => async (dispatch) => {
  try {
    const { data } = await api.updateInvoice(id, invoice);
    dispatch({ type: UPDATE, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const markInvoiceForPrint = (id) => async (dispatch) => {
  try {
    const { data } = await api.markInvoiceForPrint(id);
    dispatch({ type: UPDATE, payload: data });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Delete invoice
export const deleteInvoice = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteInvoice(id);
    dispatch({ type: DELETE, payload: id });
    openSnackbar("Order deleted successfully");
  } catch (error) {
    console.log(error.response);
  }
};

// Fetch deleted invoices with pagination
export const getDeletedInvoices = (page = 1, limit = 25, startDate = null, endDate = null) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchDeletedInvoices(page, limit, startDate, endDate);
    dispatch({ type: FETCH_DELETED_INVOICES, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

// Fetch all deleted invoices without pagination
export const getAllDeletedInvoices = (startDate = null, endDate = null) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchAllDeletedInvoices(startDate, endDate);
    dispatch({ type: FETCH_DELETED_INVOICES, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

// Soft delete invoice
export const softdeleteInvoice = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.softdeleteInvoice(id);
    dispatch({ type: SOFTDELETE, payload: id });
    openSnackbar("Invoice deleted successfully");
  } catch (error) {
    console.log(error.response);
  }
};

// Fetch canceled invoices with pagination
export const getCanceledInvoices = (page = 1, limit = 25, startDate = null, endDate = null) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchCanceledInvoices(page, limit, startDate, endDate);
    dispatch({ type: FETCH_CANCELED_INVOICES, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

// Fetch complimentary invoices with pagination
export const getComplimentaryInvoices = (page = 1, limit = 25, startDate = null, endDate = null) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchComplimentaryInvoices(page, limit, startDate, endDate);
    dispatch({ type: FETCH_COMPLIMENTARY_INVOICES, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

// Cancel invoice
export const cancelInvoice = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.cancelInvoice(id);
    dispatch({ type: CANCEL_INVOICE, payload: id });
    openSnackbar("Invoice canceled successfully");
  } catch (error) {
    console.log(error.response);
  }
};

// Verify QR code action
export const verifyQr = (qrToken, staffId, onResult) => async (dispatch) => {
  try {
    const { data } = await api.verifyQr(qrToken, staffId);
    if (onResult) onResult(data);
  } catch (error) {
    if (error.response && error.response.data && onResult) {
      onResult({ error: error.response.data.message });
    } else {
      console.log(error);
    }
  }
};